import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Home.scss";
import { selectIcon, SVG } from "../../components/UI/selector";
import VideoCarousel from "../../components/ReusableComponents/VideoCarousel/VideoCarousel";
import { listDashboardActivities } from "../../services/CallApi";
import {
  ClassBox,
  ClassHocCarousel,
} from "../../components/ReusableComponents/LiveClassTile/ClassBox/ClassBox";
import GymRequestCard from "../../components/ReusableComponents/GymRequestCard/GymRequestCard";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import { getWhiteLabelData } from "../../services/Constants";
import { Section } from "../Sections/Sections";
import CategoryCarousel from "../../components/ReusableComponents/CategoryCarousel/CategoryCarousel";
import ClassesForCategoryCarousel from "../../components/ReusableComponents/ClassesForCategoryCarousel/ClassesForCategoryCarousel";
import { OndemandHocCarousel } from "../../components/ReusableComponents/VideoUI/VideoUI";
import { getPendingGyms } from "../../services/CommonFunction";

const Home = ({ ...props }) => {
  const { pendingGyms, defaultGym, sections } = useSelector(
    (state) => state.profile.profileData
  );
  const { isWhiteLabeled } = getWhiteLabelData();

  const [activities, setActivities] = useState({
    live_and_upcoming: null,
    my_upcoming_classes: [],
    recommendation: [],
    new_classes: [],
    activity_history: [],
    categories: [],
    trending_class: [],
    featured_categories_activities: {},
  });
  useEffect(() => {
    if (defaultGym && sections.sections.length) {
      getDashboardActivities();
    }
  }, [sections, defaultGym]);

  const getDashboardActivities = () => {
    const data = {
      limit: 20,
      offset: 0,
      gym_id: defaultGym.gym_id,
      section_name: JSON.stringify(
        sections.sections.map((section) => section.section_name)
      ),
    };
    if (sections.categories.length) {
      data.featured_category_ids = JSON.stringify(
        sections.categories.map((category) => category.category_id)
      );
    }
    listDashboardActivities(data).then((response) => {
      if (response.status) {
        setActivities(response.list);
      } else {
        ErrorUI(response.list, () => getDashboardActivities(data));
      }
    });
  };
  const sectionsUI = sections.sections.map((section, index) => {
    return (
      <Section
        key={index}
        section={section}
        gym={defaultGym}
        categories={sections.categories}
      />
    );
  });
  const cateoriesUI = sections.categories.map((category, index) => (
    <ClassesForCategoryCarousel
      key={index}
      category={category}
      shouldHitApi={false}
      activities={
        activities.featured_categories_activities[category.category_id]
      }
    />
  ));

  const classBoxArray =
    activities.live_and_upcoming && activities.live_and_upcoming.length
      ? activities.live_and_upcoming
          .slice(0, 3)
          .map((el) => <ClassBox key={el.activity_id} {...el} />)
      : null;

  return (
    <div className="Home">
      <div className="HomeHeaderSection">
        <p className="text-h1">LIVE & UPCOMING</p>
        <div className="LiveAndUpcoming box-layer1">
          {classBoxArray ? (
            classBoxArray.length === 0 ? (
              <div className="noData">
                <p>No Live & Upcoming classes at the moment.</p>
              </div>
            ) : (
              <div className="ClassListContainer">{classBoxArray}</div>
            )
          ) : null}
        </div>
        <div className="TotalClassAndCalorie box-layer1">
          <div className="statsBox box-layer2">
            <div className="iconContainer box-layer3">
              <SVG src={selectIcon("calorie")} />
            </div>
            {defaultGym && defaultGym.number_of_calories_burnt < 10 ? (
              <p>{"0" + Math.round(defaultGym.number_of_calories_burnt)}</p>
            ) : (
              <p>
                {Math.round(
                  defaultGym ? defaultGym.number_of_calories_burnt : 0
                )}
              </p>
            )}
            <p>TOTAL CALORIES BURNED</p>
          </div>
          <div className="statsBox box-layer2">
            <div className="iconContainer box-layer3">
              <SVG src={selectIcon("dumbell")} />
            </div>
            {defaultGym && defaultGym.number_of_activities_done < 10 ? (
              <p>
                {"0" +
                  Math.round(
                    defaultGym ? defaultGym.number_of_activities_done : 0
                  )}
              </p>
            ) : (
              <p>
                {Math.round(
                  defaultGym ? defaultGym.number_of_activities_done : 0
                )}
              </p>
            )}
            <p>TOTAL CLASSES</p>
          </div>
        </div>
      </div>
      {getPendingGyms(pendingGyms).length ? (
        <VideoCarousel heading="MEMBERSHIP APPROVAL PENDING">
          <GymRequestCard gymsArray={getPendingGyms(pendingGyms)} />
        </VideoCarousel>
      ) : null}
      {defaultGym ? (
        <ClassHocCarousel
          heading={"My Upcoming Classes"}
          gymIds={[defaultGym.gym_id]}
          shouldHitApi={false}
          apiData={activities.my_upcoming_classes}
        />
      ) : null}
      {defaultGym ? (
        <OndemandHocCarousel
          heading={"Recommended for you"}
          gymIds={[defaultGym.gym_id]}
          shouldHitApi={false}
          apiData={activities.recommendation}
          tileSize="small"
          showNewTag={false}
          /* showExploreAll={section.section_settings.is_see_all_required} */
        />
      ) : null}
      {defaultGym && (
        <CategoryCarousel cats={activities.categories} shouldHitApi={false} />
      )}
      {defaultGym ? cateoriesUI : null}
      {defaultGym ? (
        <OndemandHocCarousel
          heading={"Trending"}
          gymIds={[defaultGym.gym_id]}
          shouldHitApi={false}
          apiData={activities.trending_class}
          tileSize="small"
          showTrend={true}
          /* showExploreAll={section.section_settings.is_see_all_required} */
        />
      ) : null}
      {defaultGym ? (
        <OndemandHocCarousel
          heading={"New"}
          gymIds={[defaultGym.gym_id]}
          shouldHitApi={false}
          apiData={activities.new_classes}
          showNewTag={true}
          /* showExploreAll={section.section_settings.is_see_all_required} */
        />
      ) : null}
    </div>
  );
};

export default Home;
